import Vue from 'vue'
import VueRouter from 'vue-router'

const original_push = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return original_push.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

// 路由配置
const routes = [
  {
    path: '/',
    component: () => import('@/layout/index'),
    children: [
      {
        path: '',
        name: 'HomePage',
        component: () => import('@/views/home/index'),
        meta: { title: '首页', icon: 'el-icon-s-home' }
      },
      {
        path: 'devices',
        name: 'DevicesPage',
        component: () => import('@/views/device/index'),
        meta: { title: '设备展示', icon: 'el-icon-s-platform' }
      },
      {
        path: 'search',
        name: 'SearchPage',
        component: () => import('@/views/search/index'),
        meta: { title: '设备查询', icon: 'el-icon-search' }
      },
      {
        path: 'statistics',
        name: 'StatisticsPage',
        component: () => import('@/views/statistics/index'),
        meta: {
          title: '统计分析',
          icon: 'el-icon-data-analysis',
          requiresStatisticsAccess: true,
        }
      },
      {
        path: 'help',
        name: 'helpPage',
        component: () => import('@/views/help/index'),
        meta: { title: '帮助中心', icon: 'el-icon-question'}
      },
      {
        path: 'profile',
        name: 'UserProfilePage',
        component: () => import('@/views/user/profile'),
        meta: { title: '个人中心' },
        hidden: true,
      },
      // {
      //   path: 'techDocs',
      //   name: 'TechDocsPage',
      //   component: () => import('@/views/techDocs/index'),
      //   meta: { title: '技术资料', icon: 'el-icon-document' }
      // },
      // {
      //   path: 'contact',
      //   name: 'ContactPage',
      //   component: () => import('@/views/contact/index'),
      //   meta: { title: '联系我们', icon: 'el-icon-phone' }
      // }
    ]
  },
  {
    path: '/statisticslite',
    component: () => import('@/layout/LiteLayout'),
    children: [
      {
        path: '',
        name: 'StatisticsLitePage',
        component: () => import('@/views/statisticslite/index'),
        meta: { title: '统计分析' },
      },
    ],
  },
  {
    path: '/user',
    component: () => import('@/layout/UserLayout'),
    children: [
      {
        path: 'caslogin',
        name: 'CasLoginPage',
        component: () => import('@/views/user/caslogin'),
        meta: { title: '统一认证登录' }
      },
      {
        path: 'login',
        name: 'LoginPage',
        component: () => import('@/views/user/login'),
        meta: { title: '用户登录' }
      },
      {
        path: 'register',
        name: 'RegisterPage',
        component: () => import('@/views/user/register'),
        meta: { title: '用户注册' }
      }
    ]
  },
  {
    path: '/device',
    component: () => import('@/layout/CommonLayout'),
    children: [
      {
        path: '',
        name: 'DevicePage',
        component: () => import('@/views/device/device'),
        meta: { title: '设备详情' }
      },
      {
        path: 'statistics',
        name: 'DeviceStatisticsPage',
        component: () => import('@/views/device/statistics/index'),
        meta: { title: '设备数据看板' }
      }
    ]
  },
  // 404页面
  {
    path: '*',
    component: () => import('@/views/error/404'),
    hidden: true
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.NODE_ENV=='production'?'web':'', // process.env.BASE_URL,
  routes
})

// 全局前置守卫（统计分析入口仅由导航栏权限控制，不拦截直接访问 URL）
router.beforeEach((to, from, next) => {
  document.title = to.meta.title ? `${to.meta.title} - 北京理工大学设备开放共享平台` : '北京理工大学设备开放共享平台'
  next()
})

export default router 